import React, { PureComponent } from "react";
import Paging from 'components/Paging'
import 'element-theme-default';
require("./index.css");

//回复选登
export default class ReplyDigest extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
        dataList:[
            {
                title:'有关转业士官的就业问题',
                time:'2019-03-15',
                letter:'2011年后转业士官分三类:自主择业、转业、自谋职业。自谋职业就是转业回地方安排工作，又主动申请自谋职业的士官。根据《退役士兵安置条例》规定:士官服现役满12年的由人民政府安排工作。符合安排工作条件的退役士兵,退役时自愿选择自主就业的，由部队发给一次性退役金，一次性退役金由中央财政专项安排, 地方政府给予经济补助。也就是说主动在部队选择自主就业，能拿到中央财政发放的-次性退役金和地方上的补助，这样领到的钱要比回地方上再自谋职业领的补助要高的多。那么为什么会有转业士官非要在地方上申请自谋职业，而却不在部队时就主动自主择业呢?这个主动自谋职业是不是从常理上说不通，存在自相矛盾?如今最不公平的就是自谋职业士官,工作没有安排，中央的一次性退役金也没领取，就这样给主动自谋职业了。至于原因，用上面的常理一-论证， 基本上一-条也说不通 ，而且刚从部队出来的孩子很单纯，申请书、公证书、协议书-样也不少， 申诉这条路算是封死了。期望上级部门能关心一下这些自谋职业士官，地方政府部门就应该补偿他们中央财政本应发放的一-次性退役金。况且国家法律并没有回地方再自谋职业这一条文， 下位政策服从国家法律这是基本的常识。',
                reply:'您好，非常感谢您的来信!为给退役士兵更多选择，更好地维护和保障他们的合法权益，《关于进一步加强由政府安排工作退役士兵就业安置工作的意见》(退役军人部发(2018) 27号)文件已经明确，选择政府安排工作人员回到地方后，仍可选择领取- -次性就业经济补助金(金额为自主就业一-次性退役金和地方一-次性经济补助金 之和的80%)。感谢你对退役军人工作的关心和支持!'
            }
        ]  
    }
  }

  render() {
    let { dataList} = this.state;
    return (
      <div className="content_list">
        <div className="answer">
        <div className="answer_title"><div>回复选登</div></div>
        {dataList.map(item=>{
            return (
            <div className="answer_cont">
                <div className="answer_issue clear">
                    <div>{item.title}</div>
                     <div>{item.time}</div>
                </div>
                <div className="answer_issue_cont">
                  <span>来信: </span>
                   <span>{item.letter}</span>
                </div>
                <div className="answer_issue_cont">
                  <span>回复: </span>
                    <span>{item.reply}</span>
                </div>
              </div>
            )
        })}
        <Paging total={1} pageSize={10} currentPage={1} />
      </div>
      </div>
    );
  }
}
